export function formatCurrency(value: number, options?: Intl.NumberFormatOptions): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    ...options,
  }).format(value);
}

export const formatCurrencyNullable = (value: unknown): string | null => {
  if (value === null || value === undefined) return null;
  const num = Number(value);
  if (Number.isNaN(num)) return null;
  return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

/**
 * Preço de plano vindo do catálogo do core como Decimal serializado ("599", "997.90"): sem
 * centavos quando é inteiro ("R$ 599"), com centavos quando não é ("R$ 997,90"); "—" se não for
 * número. Usado pelos cards dos funis self de Notificação e da Lexi.
 *
 * @example formatarPrecoDePlano('599') // "R$ 599"
 */
export const formatarPrecoDePlano = (preco: string): string => {
  const valor = Number(preco);
  if (!Number.isFinite(valor)) return '—';
  return formatCurrency(
    valor,
    Number.isInteger(valor) ? { minimumFractionDigits: 0, maximumFractionDigits: 0 } : undefined,
  );
};
